import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ProfileProvider, useProfile } from "@/context/ProfileContext";
import { sound } from "@/lib/sound";
import ProfileSelect from "@/pages/ProfileSelect";
import Hub from "@/pages/Hub";
import WorldMap from "@/pages/WorldMap";
import Learn from "@/pages/Learn";
import Rewards from "@/pages/Rewards";
import Profile from "@/pages/Profile";
import Shop from "@/pages/Shop";
import GamePlay from "@/games/GamePlay";

function RequireProfile({ children }) {
  const { profile, loading } = useProfile();
  if (loading) {
    return (
      <div className="mr-bg min-h-screen flex items-center justify-center">
        <div className="text-white/70 font-bold animate-pulse">Loading…</div>
      </div>
    );
  }
  if (!profile) return <Navigate to="/" replace />;
  return children;
}

function App() {
  useEffect(() => {
    const onFirst = () => {
      sound.resume();
      if (!sound.isMuted()) sound.startMusic();
      window.removeEventListener("pointerdown", onFirst);
    };
    window.addEventListener("pointerdown", onFirst);
    return () => window.removeEventListener("pointerdown", onFirst);
  }, []);

  return (
    <div className="App">
      <ProfileProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ProfileSelect />} />
            <Route path="/hub" element={<RequireProfile><Hub /></RequireProfile>} />
            <Route path="/map" element={<RequireProfile><WorldMap /></RequireProfile>} />
            <Route path="/learn" element={<RequireProfile><Learn /></RequireProfile>} />
            <Route path="/rewards" element={<RequireProfile><Rewards /></RequireProfile>} />
            <Route path="/shop" element={<RequireProfile><Shop /></RequireProfile>} />
            <Route path="/profile" element={<RequireProfile><Profile /></RequireProfile>} />
            <Route path="/play/:gameType" element={<RequireProfile><GamePlay /></RequireProfile>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="dark" richColors />
      </ProfileProvider>
    </div>
  );
}

export default App;
